import { Fragment, useState } from "react"

function withLineBreaks(text) {
    // check for <br /> or /n or /r/n
    const lineBreakSymbols = /<br\s*\/?>|\r?\n/i;
    return text.split(lineBreakSymbols).map((line, i) => (
        <Fragment key={i}>
            {line}
            {i < text.split(lineBreakSymbols).length - 1 && <br />}
        </Fragment>
    ));
}

export default function ListEvent({ event, handleSelectEvent }) {

    return (
        <div className="list-event">
            <span className="le-title">{event.summary}</span>
            <span className="le-place">📍 {event.location}</span>
            <span className="le-time">{event.date}</span>
            <span className="le-description">
                {withLineBreaks(
                    event.description.slice(0,51)+(event.description.length > 50 ? "... " : "")
                )}
            </span>
            <button className="le-seemore" onClick={() => handleSelectEvent(event.id)}>See More</button>
        </div>
    )
}
